import { useRef } from "react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import PricingCards from "@/components/PricingCards";
import Addons from "@/components/Addons";
import FinalCta from "@/components/FinalCta";
import { usePageMeta } from "@/utils/pageMeta";
import { useTrackOnVisible } from "@/utils/analytics";

const Pricing = () => {
  const pricingRef = useRef(null);
  useTrackOnVisible(pricingRef, "view_pricing", { location: "pricing_page" });
  usePageMeta(
    "Tarifs — ActiPilote",
    "Découvrez les offres ActiPilote : PRO 99 €/mois, BUSINESS 149 €/mois, PREMIUM 249 €/mois et ENTERPRISE sur devis. La plateforme tout-en-un des professionnels du loisir."
  );

  return (
    <>
      <section data-testid="pricing-page-hero" className="relative overflow-hidden pt-28 pb-12 sm:pt-36 sm:pb-16">
        <div className="bg-grid-faint pointer-events-none absolute inset-0" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal className="mx-auto max-w-2xl text-center">
            <Eyebrow>Tarifs</Eyebrow>
            <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">
              Une offre adaptée à votre structure.
            </h1>
            <p className="mt-5 text-base leading-relaxed text-navy/60 sm:text-lg">
              Des offres simples, adaptées à la taille de votre activité. Commencez avec l'essentiel et faites évoluer ActiPilote avec votre entreprise.
            </p>
          </Reveal>
        </div>
      </section>

      <section ref={pricingRef} className="pb-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <PricingCards />
          <Reveal className="mt-10">
            <p data-testid="pricing-note" className="mx-auto max-w-2xl text-center text-sm leading-relaxed text-navy/50">
              Paiement en ligne disponible prochainement — aujourd'hui, votre mise en route se fait avec notre équipe.
            </p>
          </Reveal>
        </div>
      </section>

      <Addons />

      <FinalCta />
    </>
  );
};

export default Pricing;
